export const ThinCheckboxIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24">
    <rect
      x="4.5"
      y="4.5"
      width="15"
      height="15"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.25"
    />
  </svg>
);
